'use client';

import { useFlags } from 'launchdarkly-react-client-sdk';
import { Typography } from 'src/components/PulseUI';
import { handleNumericValue } from 'src/utils/handleNumericValue/handleNumericValue';
import useTableFilterSelections from 'src/hooks/filters/useTableFilterSelections';

const NewTrendVolumeCell = ({ row, field, searchId, location }) => {
  const { showEncountersTotals } = useFlags();
  // Get the apiVolumeFilterFormat which contains settings for all columns
  const { apiVolumeFilterFormat } = useTableFilterSelections(location);

  // Get the column settings for this specific searchId (composite key)
  let columnSettings = apiVolumeFilterFormat[searchId];

  // Fallback: if searchId lookup fails, try to find any settings in apiVolumeFilterFormat
  if (!columnSettings && Object.keys(apiVolumeFilterFormat).length > 0) {
    // Use the first available composite key settings as fallback
    const firstAvailableKey = Object.keys(apiVolumeFilterFormat)[0];
    columnSettings = apiVolumeFilterFormat[firstAvailableKey];
  }

  // Get the type from the column settings, default to 'claims' if not found
  const columnType = columnSettings?.type || 'claims';

  // For encounters (cohort) columns, source the claims trend from encounters
  // instead (label unchanged). Gated by the flag; only swaps the claims metric.
  const isEncounters = !!showEncountersTotals && !!columnSettings?.cohort_id;

  // Use the composite searchId key for data access
  const volume =
    columnType === 'patients'
      ? row?.patients_trends?.[searchId]?.[field]
      : isEncounters
        ? row?.encounters_trends?.[searchId]?.[field]
        : row?.claims_trends?.[searchId]?.[field];

  return (
    <Typography variant="body2" bold>{handleNumericValue(volume) || 0}</Typography>
  );
};

export default NewTrendVolumeCell;
